import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Импортируем все переводы
import enCommon from "./locales/en/common.json";
import enDashboard from "./locales/en/dashboard.json";
import enUsers from "./locales/en/users.json";
import enPayments from "./locales/en/payments.json";
import enPrograms from "./locales/en/programs.json";
import enRoles from "./locales/en/roles.json";
import enSettings from "./locales/en/settings.json";
import enTranslation from "./locales/en/translation.json";
import enTree from "./locales/en/tree.json";
import enWallets from "./locales/en/wallets.json";
import enWebhooks from "./locales/en/webhooks.json";
import enApiKeys from "./locales/en/apikeys.json";
import enApiStatistics from "./locales/en/apiStatistics.json";
import enMarathon from "./locales/en/marathon.json";
import enSafe from "./locales/en/safe.json";
import enMarathonStatistics from "./locales/en/marathon_statistics.json";
import enStatistics from "./locales/en/statistics.json";
import enNotifications from "./locales/en/notifications.json";

import ruCommon from "./locales/ru/common.json";
import ruDashboard from "./locales/ru/dashboard.json";
import ruUsers from "./locales/ru/users.json";
import ruPayments from "./locales/ru/payments.json";
import ruPrograms from "./locales/ru/programs.json";
import ruRoles from "./locales/ru/roles.json";
import ruSettings from "./locales/ru/settings.json";
import ruTranslation from "./locales/ru/translation.json";
import ruTree from "./locales/ru/tree.json";
import ruWallets from "./locales/ru/wallets.json";
import ruWebhooks from "./locales/ru/webhooks.json";
import ruApiKeys from "./locales/ru/apikeys.json";
import ruApiStatistics from "./locales/ru/apiStatistics.json";
import ruMarathon from "./locales/ru/marathon.json";
import ruSafe from "./locales/ru/safe.json";
import ruMarathonStatistics from "./locales/ru/marathon_statistics.json";
import ruStatistics from "./locales/ru/statistics.json";
import ruNotifications from "./locales/ru/notifications.json";

import ukCommon from "./locales/uk/common.json";
import ukDashboard from "./locales/uk/dashboard.json";
import ukUsers from "./locales/uk/users.json";
import ukPayments from "./locales/uk/payments.json";
import ukPrograms from "./locales/uk/programs.json";
import ukRoles from "./locales/uk/roles.json";
import ukSettings from "./locales/uk/settings.json";
import ukTranslation from "./locales/uk/translation.json";
import ukTree from "./locales/uk/tree.json";
import ukWallets from "./locales/uk/wallets.json";
import ukWebhooks from "./locales/uk/webhooks.json";
import ukApiKeys from "./locales/uk/apikeys.json";
import ukApiStatistics from "./locales/uk/apiStatistics.json";
import ukMarathon from "./locales/uk/marathon.json";
import ukSafe from "./locales/uk/safe.json";
import ukMarathonStatistics from "./locales/uk/marathon_statistics.json";
import ukStatistics from "./locales/uk/statistics.json";
import ukNotifications from "./locales/uk/notifications.json";

import kaCommon from "./locales/ka/common.json";
import kaDashboard from "./locales/ka/dashboard.json";
import kaUsers from "./locales/ka/users.json";
import kaPayments from "./locales/ka/payments.json";
import kaPrograms from "./locales/ka/programs.json";
import kaRoles from "./locales/ka/roles.json";
import kaSettings from "./locales/ka/settings.json";
import kaTranslation from "./locales/ka/translation.json";
import kaTree from "./locales/ka/tree.json";
import kaWallets from "./locales/ka/wallets.json";
import kaWebhooks from "./locales/ka/webhooks.json";
import kaApiKeys from "./locales/ka/apikeys.json";
import kaApiStatistics from "./locales/ka/apiStatistics.json";
import kaMarathon from "./locales/ka/marathon.json";
import kaSafe from "./locales/ka/safe.json";
import kaMarathonStatistics from "./locales/ka/marathon_statistics.json";
import kaStatistics from "./locales/ka/statistics.json";
import kaNotifications from "./locales/ka/notifications.json";

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    users: enUsers,
    payments: enPayments,
    programs: enPrograms,
    roles: enRoles,
    settings: enSettings,
    translation: enTranslation,
    tree: enTree,
    wallets: enWallets,
    webhooks: enWebhooks,
    apikeys: enApiKeys,
    apiStatistics: enApiStatistics,
    marathon: enMarathon,
    safe: enSafe,
    marathon_statistics: enMarathonStatistics,
    statistics: enStatistics,
    notifications: enNotifications,
  },
  ru: {
    common: ruCommon,
    dashboard: ruDashboard,
    users: ruUsers,
    payments: ruPayments,
    programs: ruPrograms,
    roles: ruRoles,
    settings: ruSettings,
    translation: ruTranslation,
    tree: ruTree,
    wallets: ruWallets,
    webhooks: ruWebhooks,
    apikeys: ruApiKeys,
    apiStatistics: ruApiStatistics,
    marathon: ruMarathon,
    safe: ruSafe,
    marathon_statistics: ruMarathonStatistics,
    statistics: ruStatistics,
    notifications: ruNotifications,
  },
  uk: {
    common: ukCommon,
    dashboard: ukDashboard,
    users: ukUsers,
    payments: ukPayments,
    programs: ukPrograms,
    roles: ukRoles,
    settings: ukSettings,
    translation: ukTranslation,
    tree: ukTree,
    wallets: ukWallets,
    webhooks: ukWebhooks,
    apikeys: ukApiKeys,
    apiStatistics: ukApiStatistics,
    marathon: ukMarathon,
    safe: ukSafe,
    marathon_statistics: ukMarathonStatistics,
    statistics: ukStatistics,
    notifications: ukNotifications,
  },
  ka: {
    common: kaCommon,
    dashboard: kaDashboard,
    users: kaUsers,
    payments: kaPayments,
    programs: kaPrograms,
    roles: kaRoles,
    settings: kaSettings,
    translation: kaTranslation,
    tree: kaTree,
    wallets: kaWallets,
    webhooks: kaWebhooks,
    apikeys: kaApiKeys,
    apiStatistics: kaApiStatistics,
    marathon: kaMarathon,
    safe: kaSafe,
    marathon_statistics: kaMarathonStatistics,
    statistics: kaStatistics,
    notifications: kaNotifications,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "ru", // язык по умолчанию
    fallbackLng: "ru",
    ns: [
      "common",
      "dashboard",
      "users",
      "payments",
      "programs",
      "roles",
      "settings",
      "translation",
      "tree",
      "wallets",
      "webhooks",
      "apikeys",
      "apiStatistics",
      "marathon",
      "safe",
      "marathon_statistics",
      "statistics",
      "notifications",
    ],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
